import { Address } from '@root/entities/address/Address'

import type { OmitKey } from '@blade/std-lib'
import type { ServicesApi } from '@root/shared/api'

export type Audit = OmitKey<NonNullable<ServicesApi.PairAuditDto>, 'meta'> & {
  meta: {
    lpCreatorAddress: Address | undefined
    deployerAddress: Address | undefined
  }
}
export type AuditStatus = Audit['overAllChecks']['overall']

export const isSafe = (check: { status: AuditStatus }) =>
  check.status === 'Safe'

export const totalChecks = (audit: Audit) => {
  return (
    audit.overAllChecks.safeCount +
    audit.overAllChecks.dangerCount +
    audit.overAllChecks.warningCount
  )
}

export const fromDto = (dto: ServicesApi.PairAuditDto) => {
  const isUnknown = (address: string) => address.toLowerCase() === 'unknown'
  return {
    ...dto,
    meta: {
      lpCreatorAddress: isUnknown(dto.meta.lpCreatorAddress)
        ? undefined
        : Address(dto.meta.lpCreatorAddress),
      deployerAddress: isUnknown(dto.meta.deployerAddress)
        ? undefined
        : Address(dto.meta.deployerAddress),
    },
  }
}
